import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Coordinate from '../../geom/Coordinate';
import DoubleBits from './DoubleBits';
import Envelope from '../../geom/Envelope';
var Key = /*#__PURE__*/function () {
  function Key() {
    _classCallCheck(this, Key);
    Key.constructor_.apply(this, arguments);
  }
  _createClass(Key, [{
    key: "getLevel",
    value: function getLevel() {
      return this._level;
    }
  }, {
    key: "computeKey",
    value: function computeKey() {
      if (arguments.length === 1) {
        var itemEnv = arguments[0];
        this._level = Key.computeQuadLevel(itemEnv);
        this._env = new Envelope();
        this.computeKey(this._level, itemEnv);
        while (!this._env.contains(itemEnv)) {
          this._level += 1;
          this.computeKey(this._level, itemEnv);
        }
      } else if (arguments.length === 2) {
        var level = arguments[0],
          _itemEnv = arguments[1];
        var quadSize = DoubleBits.powerOf2(level);
        this._pt.x = Math.floor(_itemEnv.getMinX() / quadSize) * quadSize;
        this._pt.y = Math.floor(_itemEnv.getMinY() / quadSize) * quadSize;
        this._env.init(this._pt.x, this._pt.x + quadSize, this._pt.y, this._pt.y + quadSize);
      }
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      return this._env;
    }
  }, {
    key: "getCentre",
    value: function getCentre() {
      return new Coordinate((this._env.getMinX() + this._env.getMaxX()) / 2, (this._env.getMinY() + this._env.getMaxY()) / 2);
    }
  }, {
    key: "getPoint",
    value: function getPoint() {
      return this._pt;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._pt = new Coordinate();
      this._level = 0;
      this._env = null;
      var itemEnv = arguments[0];
      this.computeKey(itemEnv);
    }
  }, {
    key: "computeQuadLevel",
    value: function computeQuadLevel(env) {
      var dx = env.getWidth();
      var dy = env.getHeight();
      var dMax = dx > dy ? dx : dy;
      var level = DoubleBits.exponent(dMax) + 1;
      return level;
    }
  }]);
  return Key;
}();
export { Key as default };